import { ACHProcessorData as ach } from "globalConstants";

export const resetAchFields = {
	[ach.MonthlyVolumeAch.name]: null,
	[ach.MonthlyVolumeAchPayouts.name]: null,
	[ach.HighTicketAch.name]: null,
	[ach.HighTicketAchPayouts.name]: null,
	[ach.TicketCountAch.name]: null,
	[ach.TicketCountAchPayouts.name]: null,
	[ach.StatementDescriptor.name]: null,
	[ach.UseOfPaymentServiceDescription.name]: null,
	[ach.IsApplyBankAccountData.name]: null,
	[ach.BillingRouting.name]: null,
	[ach.BillingBank.name]: null,
	[ach.BillingAccount.name]: null,
	[ach.BillingAccountName.name]: null,
	[ach.CustomerType.name]: null,
	[ach.PaymentAuthorizationType.name]: null,
};
